export default __webpack_public_path__ + "static/clicknpay-994785fb2cfdc6bb727142b52fb76272.svg";